/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationsResponse {
    getFixupPrototypeFunction() { return ListRecommendationsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationsResponse>): ListRecommendationsResponse {
        let obj = Object.assign(new ListRecommendationsResponse(), model);
        ListRecommendationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationsResponse>): ListRecommendationsResponse {
        if (!model) return null;
        return ListRecommendationsResponse.newInstance(<ListRecommendationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationsResponse) {
        if (!obj) return;

        models.ListRecommendationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationsResponse): boolean {
        Object.setPrototypeOf(obj, ListRecommendationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.Recommendation.fixupPrototype(val);
            }
        }
    }

    /**
     * Total count
     */
    total_count: number;

    /**
     * Page count
     */
    page_count: number;

    /**
     * Recommendations
     */
    recommendations: Array<models.Recommendation>;

}
